if (!customElements.get('badges-row-slider')) {
  customElements.define(
    'badges-row-slider',
    class BadgesRowSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.swiper');
        this.itemsDesktop = parseInt(this.dataset.itemsDesktop, 10) || 4;
        this.itemsMobile = parseInt(this.dataset.itemsMobile, 10) || 2;
        this.gap = parseInt(this.dataset.gap, 10) || 24;

        this.initSlider();
      }

      initSlider() {
        const options = {
          slidesPerView: this.itemsMobile,
          spaceBetween: this.gap,
          navigation: false,
          pagination: false,
          watchOverflow: true,
          threshold: 2,
          grabCursor: true,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.5,
            thresholdDelta: 30,
            thresholdTime: 500,
          },
          breakpoints: {
            768: {
              slidesPerView: this.itemsDesktop,
            },
          },
        };

        this.sliderInstance = new FoxTheme.Carousel(this.viewport, options);
        this.sliderInstance.init();
      }
    }
  );
}
